export default {
  prescriptions: {
    title: 'Gestion des Prescriptions',
    subtitle: 'Validation et supervision des prescriptions médicales',
    refresh: 'Actualiser',
    filters: {
      search: 'Recherche',
      searchPlaceholder: 'Patient, médecin, médicament...',
      status: 'Statut',
      statusAll: 'Tous les statuts',
      priority: 'Priorité',
      priorityAll: 'Toutes les priorités',
      controlled: 'Substance Contrôlée',
      controlledAll: 'Tous',
      yes: 'Oui',
      no: 'Non'
    },
    table: {
      prescription: 'Prescription',
      patient: 'Patient',
      doctor: 'Médecin',
      priority: 'Priorité',
      status: 'Statut',
      controlled: 'Contrôlée',
      date: 'Date',
      actions: 'Actions',
      loading: 'Chargement des prescriptions...',
      noResults: 'Aucune prescription trouvée',
      controlledTooltip: 'Substance contrôlée',
      uncontrolledTooltip: 'Substance non contrôlée',
      createdAt: 'Créée le {{date}}',
      viewDetails: 'Voir les détails',
      validate: 'Valider la prescription',
      cancel: 'Annuler la prescription'
    },
    pagination: {
      previous: 'Précédent',
      next: 'Suivant',
      showing: 'Affichage de {{start}} à {{end}} sur {{total}} résultats',
      pageOf: 'Page {{page}} sur {{totalPages}}'
    },
    statusNames: {
      DRAFT: 'Brouillon',
      ACTIVE: 'Active',
      FILLED: 'Dispensée',
      CANCELLED: 'Annulée',
      EXPIRED: 'Expirée'
    },
    priorityNames: {
      LOW: 'Basse',
      NORMAL: 'Normale',
      HIGH: 'Haute',
      URGENT: 'Urgente'
    },
    stats: {
      total: 'Total Prescriptions',
      controlled: 'Substances Contrôlées',
      renewable: 'Prescriptions Renouvelables',
      emergencies: 'Urgences'
    }
  },
  consultations: {
    filters: {
      search: 'Recherche',
      searchPlaceholder: 'Patient, médecin, symptômes...',
      status: 'Statut',
      statusAll: 'Tous les statuts',
      urgency: 'Urgence',
      urgencyAll: 'Toutes les urgences',
      dateFrom: 'Date de début',
      statusNames: {
        PENDING: 'En attente',
        SCHEDULED: 'Programmée',
        IN_WAITING_ROOM: 'En salle d\'attente',
        IN_PROGRESS: 'En cours',
        COMPLETED: 'Terminée',
        CANCELLED: 'Annulée'
      },
      urgencyNames: {
        NORMAL: 'Normal',
        URGENT: 'Urgent',
        EMERGENCY: 'Urgence',
        CRITICAL: 'Critique'
      }
    },
    table: {
      date: 'Date',
      patient: 'Patient',
      doctor: 'Médecin',
      urgency: 'Urgence',
      status: 'Statut',
      prescription: 'Prescription',
      actions: 'Actions',
      loading: 'Chargement des consultations...',
      noResults: 'Aucune consultation trouvée',
      noPrescription: 'Aucune'
    },
    pagination: {
      previous: 'Précédent',
      next: 'Suivant',
      showing: 'Affichage de {{start}} à {{end}} sur {{total}} résultats',
      pageOf: 'Page {{page}} sur {{totalPages}}'
    },
    details: {
      title: 'Détails de la Consultation {{number}}',
      close: 'Fermer',
      generalInfo: 'Informations Générales',
      status: 'Statut:',
      urgency: 'Urgence:',
      date: 'Date:',
      type: 'Type:',
      participants: 'Participants',
      patient: 'Patient',
      doctor: 'Médecin',
      medicalInfo: 'Informations Médicales',
      symptoms: 'Symptômes',
      diagnosis: 'Diagnostic',
      recommendations: 'Recommandations',
      medicalQuestion: 'Question Médicale',
      prescriptionTitle: 'Prescription',
      medication: 'Médicament',
      priority: 'Priorité',
      associatedAppointment: 'Rendez-vous Associé',
      id: 'ID',
      cancel: {
        title: 'Annuler la Consultation',
        confirmText: 'Êtes-vous sûr de vouloir annuler la consultation de {{patient}} avec le Dr. {{doctor}} ?',
        reasonLabel: 'Raison de l\'annulation',
        reasonPlaceholder: 'Expliquez la raison de cette annulation...',
        btnCancel: 'Annuler',
        btnConfirm: 'Confirmer l\'annulation',
        btnPending: 'Annulation...'
      },
      priorityChange: {
        title: 'Changer la Priorité',
        infoText: 'Consultation de {{patient}} avec le Dr. {{doctor}}',
        newPriorityLabel: 'Nouvelle Priorité',
        priorityLow: 'Basse',
        priorityNormal: 'Normale',
        priorityHigh: 'Haute',
        reasonLabel: 'Raison du changement',
        reasonPlaceholder: 'Expliquez la raison de ce changement...',
        btnCancel: 'Annuler',
        btnConfirm: 'Changer la priorité',
        btnPending: 'Mise à jour...'
      }
    },
    stats: {
      total: 'Total Consultations',
      recent: 'Consultations Récentes',
      avgDuration: 'Durée Moyenne',
      emergencies: 'Urgences'
    },
    moderation: {
      loading: 'Chargement Modération...',
      title: 'Consultations à Modérer',
      realTime: 'Temps Réel',
      moderationTag: 'Modération',
      allBtn: 'Toutes',
      urgentBtn: 'Urgentes',
      refreshBtn: 'Actualiser',
      stats: {
        total: 'Total',
        inProgress: 'En cours',
        critical: 'Critiques',
        interventions: 'Interventions'
      },
      bulk: {
        selected: '{{count}} sélectionnée(s)',
        cancelBtn: 'Annuler en masse',
        deselectBtn: 'Désélectionner',
        promptReason: 'Raison de l\'annulation groupée ({{count}} consultations):'
      },
      table: {
        titleUrgent: 'Consultations Critiques',
        titleAll: 'Consultations à Modérer',
        entries: '{{count}} entrées',
        selectLabel: 'Sélectionner la consultation {{id}}',
        symptoms: 'Symptômes:',
        actions: {
          cancel: 'Annuler',
          pause: 'Pause',
          escalate: 'Escalader',
          resume: 'Reprendre',
          forceComplete: 'Forcer la fin'
        },
        noResults: 'Aucune consultation à modérer',
        promptCancelReason: 'Raison de l\'annulation:',
        promptInterventionReason: 'Raison de l\'intervention ({{action}}):'
      }
    }
  },
  notifications: {
    broadcast: {
      title: 'Diffusion Générale',
      live: 'Live',
      titleLabel: 'Titre de la notification',
      titlePlaceholder: 'Titre de la diffusion',
      messageLabel: 'Message',
      messagePlaceholder: 'Contenu de la notification',
      typeLabel: 'Type',
      priorityLabel: 'Priorité',
      rolesLabel: 'Rôles ciblés',
      byRoles: 'Par rôles',
      byUsers: 'Utilisateurs',
      usersPlaceholder: 'IDs des utilisateurs (séparés par des virgules)',
      expirationLabel: 'Expiration (jours)',
      btnBroadcast: 'Lancer la diffusion',
      btnPending: 'Diffusion en cours...'
    },
    types: {
      SYSTEM_NOTIFICATION: 'Notification système',
      APPOINTMENT_REMINDER: 'Rappel rendez-vous',
      MESSAGE_RECEIVED: 'Message reçu',
      TELECONSULTATION_STARTED: 'Téléconsultation lancée',
      PRESCRIPTION_CREATED: 'Prescription créée',
      PRESCRIPTION_READY: 'Prescription prête',
      PRESCRIPTION_EXPIRED: 'Prescription expirée'
    },
    priorities: {
      LOW: 'Basse',
      NORMAL: 'Normale',
      HIGH: 'Haute',
      URGENT: 'Urgente'
    },
    registry: {
      title: 'Registre des Notifications',
      entriesCount: '{{count}} entrées',
      searchPlaceholder: 'Rechercher une notification...',
      typeAll: 'Tous types',
      typeSystem: 'Système',
      typeReminder: 'Rappel RDV',
      typeMessage: 'Message',
      typePrescription: 'Prescription',
      btnNew: 'Nouvelle notification',
      table: {
        notification: 'Notification',
        recipient: 'Destinataire',
        type: 'Type',
        status: 'Statut',
        date: 'Date',
        actions: 'Actions',
        loading: 'Chargement...',
        noResults: 'Aucune notification',
        read: 'Lu',
        unread: 'Non lu',
        viewDetails: 'Voir les détails',
        delete: 'Supprimer',
        deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette notification ?'
      },
      details: {
        title: 'Détails Notification',
        close: 'Fermer',
        notificationTitle: 'Titre',
        message: 'Message',
        type: 'Type',
        status: 'Statut',
        recipient: 'Destinataire',
        role: 'Rôle: {{role}}',
        createdAt: 'Créée le',
        readAt: 'Lue le',
        expiresAt: 'Expire le',
        extraData: 'Données supplémentaires'
      },
      create: {
        title: 'Nouvelle Notification',
        btnCancel: 'Annuler',
        btnConfirm: 'Créer la notification',
        btnPending: 'Création...'
      }
    },
    templates: {
      name: 'Modèle',
      subject: 'Sujet',
      content: 'Contenu',
      variables: 'Variables'
    },
    createSuccess: 'Notification créée avec succès',
    broadcastSuccess: 'Diffusion lancée avec succès',
    deleteSuccess: 'Notification supprimée avec succès',
    loadError: 'Erreur lors du chargement des communications',
    consoleSecure: 'Console Sécurisée',
    systemTitle: 'Communications Système',
    refreshBtn: 'Actualiser',
    tabNotifications: 'Notifications',
    tabTemplates: 'Templates',
    tabBroadcast: 'Diffusion'
  },
  permissions: {
    searchPlaceholder: 'Rechercher des permissions...',
    categoryAll: 'Toutes les catégories',
    noResults: 'Aucune permission trouvée',
    resource: 'Resource',
    action: 'Action',
    description: 'Description',
    id: 'ID',
    roleAssignedSuccess: 'Rôle assigné avec succès',
    checkSuccess: 'Vérification effectuée',
    loadError: 'Erreur lors du chargement des permissions',
    title: 'Gestion des Permissions',
    subtitle: "Contrôle d'accès et gestion des rôles utilisateur",
    refresh: 'Actualiser',
    tabRoles: 'Rôles',
    tabPermissions: 'Permissions',
    tabUsers: 'Utilisateurs',
    tabAudit: 'Audit',
    rolesList: {
      title: 'Rôles Système',
      subtitle: 'Gestion des rôles et de leurs permissions',
      colRole: 'Rôle',
      colDescription: 'Description',
      colPermissions: 'Permissions',
      colUsers: 'Utilisateurs',
      colSystem: 'Système',
      colActions: 'Actions',
      loading: 'Chargement des rôles...',
      noRoles: 'Aucun rôle trouvé',
      viewDetails: 'Voir les détails',
      assignRole: 'Assigner ce rôle',
      detailsTitle: 'Détails du rôle {{name}}',
      infoTitle: 'Informations générales',
      nameLabel: 'Nom :',
      usersLabel: 'Utilisateurs :',
      systemRoleLabel: 'Rôle système :',
      yes: 'Oui',
      no: 'Non',
      descLabel: 'Description',
      permissionsTitle: 'Permissions ({{count}})',
      assignTitle: 'Assigner le rôle {{name}}',
      assignDesc: "Entrez l'ID de l'utilisateur à qui assigner ce rôle",
      userIdLabel: 'ID Utilisateur',
      userIdPlaceholder: "Entrez l'ID utilisateur",
      reasonLabel: 'Raison',
      reasonPlaceholder: 'Expliquez la raison de ce changement...',
      cancelBtn: 'Annuler',
      assignBtn: 'Assigner',
      assignPending: 'Assignation...'
    },
    auditList: {
      title: 'Audit des Permissions',
      subtitle: 'Historique des changements de rôles et permissions',
      colAction: 'Action',
      colUser: 'Utilisateur',
      colTarget: 'Cible',
      colDetails: 'Détails',
      colDate: 'Date',
      loading: "Chargement de l'audit...",
      noLogs: "Aucun log d'audit trouvé"
    }
  },
  settings: {
    title: 'Paramètres du Compte',
    subtitle: 'Gérez vos informations personnelles et la sécurité de votre accès administrateur',
    profileTab: 'Profil Public',
    securityTab: 'Sécurité',
    notificationsTab: 'Notifications',
    adminLevel: 'Niveau Administrateur',
    adminLevelDesc: "Votre compte bénéficie d'une protection renforcée et de privilèges système étendus.",
    mfaActive: 'MFA Actif',
    adminProfile: 'Profil Administrateur',
    fullName: 'Nom complet',
    proEmail: 'Email professionnel',
    saveChanges: 'Enregistrer les modifications',
    accountSecurity: 'Sécurité du Compte',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmNew: 'Confirmer le nouveau',
    changePasswordWarning: "Le changement de mot de passe invalidera toutes vos sessions actives sur d'autres appareils pour des raisons de sécurité.",
    updateSecurity: 'Mettre à jour la sécurité',
    profileSuccess: 'Profil mis à jour avec succès',
    profileError: 'Erreur lors de la mise à jour du profil',
    passwordsMismatch: 'Les mots de passe ne correspondent pas',
    passwordSuccess: 'Mot de passe modifié avec succès',
    passwordError: 'Erreur lors du changement de mot de passe'
  },
  users: {
    title: 'Gestion Avancée des Utilisateurs',
    subtitle: 'Administration complète des comptes utilisateur',
    filters: 'Filtres',
    refresh: 'Actualiser',
    tabUsers: 'Utilisateurs',
    tabStats: 'Statistiques',
    tabBulk: 'Actions en Masse',
    bulkActions: 'Actions en masse',
    selectedUsers: '{{count}} utilisateur(s) sélectionné(s)',
    bulkProcessedSuccess: '✅ {{count}} utilisateur(s) traité(s) avec succès',
    bulkProcessedErrors: '⚠️ {{count}} erreur(s)',
    close: 'Fermer',
    bulkSuccess: 'Action en masse exécutée avec succès',
    activateSuccess: 'Utilisateur activé avec succès',
    deactivateSuccess: 'Utilisateur désactivé avec succès',
    deleteSuccess: 'Utilisateur supprimé avec succès',
    verifySuccess: 'Utilisateur vérifié avec succès',
    selectAtLeastOne: 'Veuillez sélectionner au moins un utilisateur',
    provideReason: 'Veuillez fournir une raison pour cette action',
    exportError: "Erreur lors de l'export",
    neverConnected: 'Jamais connecté',
    today: "Aujourd'hui",
    yesterday: 'Hier',
    daysAgo: 'Il y a {{count}} jours',
    weeksAgo: 'Il y a {{count}} semaines',
    monthsAgo: 'Il y a {{count}} mois',
    loadError: 'Erreur lors du chargement de la gestion utilisateurs',
    confirmDeleteTitle: 'Confirmer la suppression',
    confirmDeleteDesc: 'Êtes-vous sûr de vouloir supprimer {{name}} ?',
    cancel: 'Annuler',
    delete: 'Supprimer',
    changeRoleTitle: 'Changer le rôle de {{name}}',
    currentRole: 'Rôle actuel :',
    newRole: 'Nouveau Rôle',
    confirm: 'Confirmer',
    roles: {
      PATIENT: 'Patient',
      DOCTOR: 'Médecin',
      ADMIN: 'Administrateur'
    },
    statistics: {
      totalUsers: 'Total Utilisateurs',
      activeUsers: 'Utilisateurs Actifs',
      verifiedUsers: 'Utilisateurs Vérifiés',
      newUsers7d: 'Nouveaux (7j)',
      byRole: 'Répartition par Rôle',
      registrationTrends30d: 'Inscriptions (30 derniers jours)',
      activityMetrics: "Métriques d'Activité",
      totalSessions: 'Sessions totales',
      activeUsers7d: 'Actifs (7j)',
      activeUsers30d: 'Actifs (30j)',
      avgSessionDuration: 'Durée moyenne'
    }
  },
  security: {
    critError: 'Échec critique du module de sécurité',
    controlCenter: 'Centre de Contrôle',
    security: 'Sécurité',
    refresh: 'Rafraîchir',
    fullAudit: 'Audit Complet',
    apiResponseTime: 'Temps de réponse API',
    stable: 'Stable',
    cpuLoad: 'Charge CPU',
    storageStatus: 'Statut du stockage',
    nodesActive: 'Nœuds actifs',
    ipAccessRestored: 'Accès restauré pour IP',
    ipBlockedSuccess: 'Périmètre sécurisé : IP bloquée',
    ruleActivated: 'Règle de protection activée',
    threatIntel: 'Threat Intelligence',
    shielding: 'Shielding (Rate Limit)',
    quantumFirewall: 'Quantum Firewall',
    auditForensic: 'Audit Forensic',
    dataIntegrity: 'Data Integrity',
    optimal: 'Optimal',
    normal: 'Normal',
    synced: 'Synchronisé',
    forensicData: 'Données Forensic',
    generalInfo: 'Informations Générales',
    eventType: 'Type d\'événement',
    severity: 'Sévérité',
    ipSource: 'IP Source',
    networkVector: 'Vecteur Réseau',
    rawPayload: 'Payload brut des détails',
    protectionAction: 'Action de protection',
    requestIntercepted: 'Requête interceptée et filtrée.',
    firewallTitle: 'Firewall & Blocage IP',
    firewallSubtitle: 'Gestion des adresses IP bloquées et règles firewall',
    blockIPBtn: 'Bloquer IP',
    thIPAddress: 'Adresse IP',
    thReason: 'Raison',
    thBlockedAt: 'Bloquée le',
    thExpiresAt: 'Expire le',
    thActions: 'Actions',
    loadingBlockedIPs: 'Chargement des IPs bloquées...',
    permanent: 'Permanent',
    noBlockedIPs: 'Aucune IP bloquée',
    unblockIPTooltip: 'Débloquer',
    totalRequests: 'Requêtes Totales',
    blocked: 'Bloquées',
    authAttempts: 'Tentatives Auth',
    successful: 'Réussies',
    failed: 'Échouées',
    suspiciousActivity: 'Activité Suspecte',
    lockedAccounts: 'Comptes Verrouillés',
    bruteForce: 'Brute force',
    attempts: 'tentatives',
    topBlockedEndpoints: 'Endpoints les Plus Bloqués',
    blocks: 'blocages',
    topCountries: 'Top Pays',
    requests: 'requêtes',
    quickActions: 'Actions Rapides',
    createRateLimit: 'Créer Rate Limit',
    limitRequestsByEndpoint: 'Limiter les requêtes par endpoint',
    blockIP: 'Bloquer IP',
    blockSuspiciousIP: 'Bloquer une adresse IP suspecte',
    viewLogs: 'Voir Logs',
    consultSecurityLogs: 'Consulter les logs de sécurité',
    newRule: 'Nouvelle Règle',
    rule: 'Règle',
    window: 'Fenêtre',
    status: 'Statut',
    loadingRules: 'Chargement des règles...',
    enabled: 'Activé',
    disabled: 'Désactivé',
    modify: 'Modifier',
    delete: 'Supprimer',
    noRateLimits: 'Aucune règle de rate limiting',
    inputValidation: 'Validation des Entrées',
    validationRulesDesc: 'Règles de validation pour sécuriser les entrées utilisateur',
    field: 'Champ',
    valueLabel: 'Valeur',
    errorMessage: "Message d'erreur",
    noValidationRules: 'Aucune règle de validation',
  },
  dataExport: {
    exportsTitle: 'Exports de Données',
    exportsDesc: 'Exporter les données système dans différents formats',
    newExport: 'Nouvel Export',
    configsTitle: "Configurations d'Export",
    loadingConfigs: 'Chargement des configurations...',
    runBtn: 'Lancer',
    noConfigs: "Aucune configuration d'export",
    backupsTitle: 'Sauvegardes Système',
    backupsDesc: 'Gérer les sauvegardes automatiques et manuelles',
    cleanBtn: 'Nettoyer',
    restoreBtn: 'Restaurer',
    newBackupBtn: 'Nouvelle Sauvegarde',
    configsBackupTitle: 'Configurations de Sauvegarde',
    statusIdle: 'En attente',
    statusRunning: 'En cours',
    statusCompleted: 'Terminée',
    statusFailed: 'Échouée',
    noBackupConfigs: 'Aucune configuration de sauvegarde',
    totalBackups: 'Total Sauvegardes',
    successful: 'Réussies',
    failed: 'Échouées',
    totalSize: 'Taille Totale',
    historyTitle: 'Historique des Sauvegardes',
    backup: 'Sauvegarde',
    size: 'Taille',
    started: 'Démarrée',
    duration: 'Durée',
    actions: 'Actions',
    loadingHistory: "Chargement de l'historique...",
    noHistory: "Aucune sauvegarde dans l'historique",
    viewDetails: 'Voir les détails',
    download: 'Télécharger',
    jobDetails: 'Détails du job',
    progress: 'Progression',
    error: 'Erreur',
    tables: 'Tables',
    restoreCrit: '⚠️ Restauration Critique',
    restoreWarning: "Cette opération va remplacer toutes les données actuelles. Assurez-vous d'avoir une sauvegarde récente.",
    backupIdLabel: 'ID de la sauvegarde',
    targetDbLabel: 'Base de données cible (optionnel)',
    irreversibleWarning: '⚠️ Cette action est IRRÉVERSIBLE et va remplacer toutes les données actuelles.',
    confirmRestore: 'Confirmer la restauration',
    cancel: 'Annuler',
    status: {
      PENDING: 'En attente',
      RUNNING: 'En cours',
      COMPLETED: 'Terminé',
      FAILED: 'Échoué'
    },
    format: {
      CSV: 'CSV',
      JSON: 'JSON',
      PDF: 'PDF',
      EXCEL: 'Excel'
    },
    restoringBtn: 'Restauration en cours...'
  },
  systemMonitoring: {
    metric: 'Métrique',
    threshold: 'Seuil',
    currentValue: 'Valeur actuelle',
    triggeredAt: 'Déclenchée',
    close: 'Fermer',
    acknowledging: 'Acquittement...',
    acknowledge: 'Acquitter',
    alertsTitle: 'Alertes Système',
    refreshBtn: 'Actualiser',
    noAlerts: 'Aucune alerte active',
    databaseTitle: 'Base de Données',
    total: 'Total',
    active: 'Actives',
    inactive: 'Inactives',
    slowQueries: 'Requêtes lentes',
    avgQueryTime: 'Temps moyen',
    apiTitle: 'API',
    successful: 'Réussies',
    failed: 'Échouées',
    avgResponseTime: 'Temps de réponse moyen',
    mostUsedEndpoints: 'Endpoints les Plus Utilisés',
    endpoint: 'Endpoint',
    method: 'Méthode',
    requests: 'Requêtes',
    avgTime: 'Temps Moyen',
    errorRate: "Taux d'Erreur",
    enableMaintenance: 'Activer la Maintenance',
    disableMaintenance: 'Désactiver la Maintenance',
    enableMaintenanceDesc: 'Cela informera les utilisateurs que le système est en maintenance.',
    disableMaintenanceDesc: "Cela réactivera l'accès normal au système.",
    maintenanceMessageLabel: 'Message de maintenance',
    maintenanceMessagePlaceholder: 'Message à afficher aux utilisateurs...',
    estimatedDurationLabel: 'Durée estimée (minutes)',
    cancelBtn: 'Annuler',
    applyingBtn: 'Application...',
    confirmBtn: 'Confirmer',
    cpuTitle: 'Processeur',
    usageLabel: 'Utilisation',
    coresLabel: 'Cœurs',
    loadAverageLabel: 'Charge moyenne',
    memoryTitle: 'Mémoire',
    totalLabel: 'Total',
    usedLabel: 'Utilisé',
    freeLabel: 'Libre',
    diskTitle: 'Stockage',
    systemInfoTitle: 'Informations Système',
    platformLabel: 'Plateforme',
    archLabel: 'Architecture',
    nodeVersionLabel: 'Node.js',
    uptimeLabel: 'Temps de fonctionnement',
    lastUpdateLabel: 'Dernière mise à jour',
    networkInterfacesTitle: 'Interfaces Réseau',
    interfaceLabel: 'Interface',
    ipAddressLabel: 'Adresse IP',
    macAddressLabel: 'Adresse MAC',
    healthTitle: 'État de Santé Global',
    healthHealthy: 'Sain',
    healthWarning: 'Attention',
    healthCritical: 'Critique',
    maintenanceBtn: 'Maintenance',
    uptimeDesc: 'Temps de fonctionnement',
    versionLabel: 'Version',
    responseTimeDesc: 'Temps de réponse',
    lastCheckDesc: 'Dernière vérification',
    externalServicesLabel: 'Services Externes',
    latencyLabel: 'Latence',
    cpuDesc: 'CPU',
    diskDesc: 'Disque',
    activeAlertsTitle: 'Alertes Actives ({{count}})',
    viewAllAlertsLink: 'Voir toutes les alertes →',
    loading: 'Chargement du monitoring temps réel...',
    realtimeTitle: 'Monitoring Temps Réel',
    subtitle: 'EKOSE - Surveillance système en direct',
    lastUpdate: 'Dernière mise à jour:',
    userStatsTitle: 'Statistiques Utilisateurs',
    totalUsers: 'Total Utilisateurs',
    doctors: 'Médecins',
    patients: 'Patients',
    online: 'En Ligne',
    systemPerfTitle: 'Performance Système',
    systemServicesTitle: 'Services Système',
    recentActivityTitle: 'Activité Récente',
    noRecentActivity: 'Aucune activité récente',
    maintenanceDefaultMessage: 'Le système est en cours de maintenance. Veuillez nous excuser pour la gêne occasionnée.',
    alertAckSuccess: 'Alerte acquittée avec succès',
    maintenanceEnabledSuccess: 'Mode maintenance activé',
    maintenanceDisabledSuccess: 'Mode maintenance désactivé',
    loadError: 'Erreur lors du chargement des données de monitoring',
    title: 'Monitoring Système',
    subtitleSystem: "Surveillance en temps réel de l'infrastructure et de l'application",
    tabOverview: "Vue d'ensemble",
    tabSystem: 'Système',
    tabApplication: 'Application',
    tabAlerts: 'Alertes',
    tabLogs: 'Logs',
    logsTitle: 'Logs Système',
    logsPlaceholder: 'Fonctionnalité de logs à implémenter'
  },
  services: {
    loading: 'Chargement des services...',
    loadError: 'Erreur lors du chargement des services',
    toggleError: 'Erreur lors de la modification du service',
    toggleSuccessReason: 'Service réactivé',
    toggleFailReason: 'Maintenance planifiée',
    title: 'Gestion des Services',
    subtitle: 'Infrastructure',
    maintenanceModeTag: 'Mode Maintenance',
    refreshBtn: 'Actualiser',
    retryBtn: 'Réessayer',
    maintenanceBtn: 'Maintenance',
    disableBtn: 'Désactiver',
    kpi: {
      active: 'Services Actifs',
      inactive: 'Services Inactifs',
      lastMaintenance: 'Dernière Maintenance',
      none: 'Aucune'
    },
    table: {
      title: 'Services ({{count}})',
      lastMaintenanceLabel: 'Dernière maintenance : {{date}}',
      statusActive: 'Actif',
      statusInactive: 'Inactif',
      btnActivate: 'Activer',
      btnDeactivate: 'Désactiver',
      cannotDisable: 'Ce service ne peut pas être désactivé',
      names: {
        database: 'Base de données',
        redis: 'Cache Redis',
        email: 'Service Email',
        notifications: 'Notifications'
      },
      descriptions: {
        database: 'Base de données PostgreSQL',
        redis: 'Cache Redis',
        email: "Service d'envoi d'emails",
        notifications: 'Service de notifications'
      }
    },
    modal: {
      enableTitle: 'Activer la maintenance',
      disableTitle: 'Désactiver la maintenance',
      enableDesc: 'Les utilisateurs verront un message de maintenance pendant cette période.',
      disableDesc: 'Les services seront de nouveau accessibles pour tous les utilisateurs.',
      reasonLabel: 'Raison (optionnel)',
      reasonPlaceholder: 'Raison de la maintenance...',
      cancelBtn: 'Annuler',
      activateBtn: 'Activer',
      reactivateBtn: 'Réactiver'
    }
  },
  doctors: {
    title: 'Gestion des Médecins',
    subtitle: 'Gérer les médecins de la plateforme EKOSE-RX',
    refresh: 'Actualiser',
    searchPlaceholder: 'Rechercher par nom, email, spécialité, ville...',
    stats: '{{count}} médecin(s) trouvé(s) sur {{total}} total',
    table: {
      name: 'Nom',
      email: 'Email',
      speciality: 'Spécialité',
      city: 'Ville',
      status: 'Statut',
      createdAt: 'Créé le',
      actions: 'Actions'
    },
    noResults: 'Aucun médecin trouvé',
    noResultsHint: 'Essayez de modifier vos critères de recherche',
    generalist: 'Généraliste',
    viewDetails: 'Voir les détails',
    approve: 'Approuver',
    suspend: 'Suspendre',
    delete: 'Supprimer',
    features: {
      suspendUnavailable: 'Fonctionnalité de suspension bientôt disponible',
      approveSuccess: 'Médecin approuvé avec succès',
      deleteSuccess: 'Médecin supprimé avec succès',
      deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce médecin ?'
    },
    errors: {
      loadError: 'Erreur lors du chargement des médecins'
    },
    statusNames: {
      ACTIVE: 'Actif',
      PENDING: 'En attente',
      SUSPENDED: 'Suspendu',
      INACTIVE: 'Inactif'
    }
  }
};
